import script from "./RevenueCardsLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./RevenueCardsLayout.vue?vue&type=script&lang=ts&setup=true"

import "./RevenueCardsLayout.vue?vue&type=style&index=0&id=a3194542&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3194542"]])

export default __exports__